<template>
  <FormHeader
    :primary-color="primaryColor"
    progress="5"
  >
    <template #title>
      <p>
        {{ __('co_reg_lander_002_step_5_text') }}
      </p>
    </template>

    <template #subtext>
      <!-- eslint-disable vue/no-v-html -->
      <div v-html="__('co_reg_lander_002_step_5_subtext')" />
      <!-- eslint-enable vue/no-v-html -->
    </template>
  </FormHeader>

  <div class="w-full flex justify-center">
    <div
      class="w-[20rem] p-4 rounded-xl"
      :style="{
        'backgroundColor': `#${exitBackgroundColor}`,
      }"
    >
      <p class="text-center text-white text-2xl font-bold p-2">
        {{ __('co_reg_lander_002_exit_text') }}
      </p>

      <div
        v-for="(campaignSub, index) in exitCampaignSubs"
        :key="index"
        class="flex justify-center"
      >
        <div class="flex justify-center bg-white m-2 w-fit">
          <ExitItem
            :campaign-sub="campaignSub"
            primary-color="1abbc3"
            secondary-color="dc6fab"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import FormHeader from '@timon/js/Templates/CO-REG-LANDER-002/Components/FormHeader.vue';
import ExitItem from '@timon/js/Components/ExitItem.vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  exitCampaignSubs: {
    type: Array,
    required: true,
  },
});

const primaryColor = ref(props.config.style?.primary);
const exitBackgroundColor = ref(props.config.style?.exit_background);
</script>
